<div class="row">
    <div class="col-12">
        <div class="d-flex align-items-center form-control p-0" style="border-width: 0px;">
            <ng-select style="flex-grow: 1; " 
                (change)="selectContact(selectedModelsArray[0]?.id)" bindLabel='fullName' [clearSearchOnAdd]="true"
                [items]="listItems$ | async" [isOpen]="(searchTermLength > minLengthTerm) " [trackByFn]="trackByFn"
                [minTermLength]="minLengthTerm" [loading]="listItemsLoading" placeholder={{searchPlaceHolderText}}
                typeToSearchText="Please enter {{minLengthTerm}} or more characters" [typeahead]="listItemsInput$"
                [(ngModel)]="selectedModelsArray" [disabled]=disabled (clear)=arrayCleared() [multiple]="true"
                [maxSelectedItems]="1">
                <ng-template ng-option-tmp let-item="item">
                    {{getDropdownName(item)}}
                </ng-template>
                <ng-template class=ng-value ng-label-tmp let-item="item">
                    <span class="ng-value-label" [ngClass]="{'ng-value-label': disabled}" style="cursor: pointer;"
                        [ngStyle]="{'cursor: default' : disabled}" (mousedown)="$event.stopPropagation()"
                        (click)="openModalEdit(item.id ,$event ); ">
                        <b *ngIf="(item.firstName)">
                            {{item.firstName}}
                        </b>
                        <b *ngIf="(item.firstName && !item.lastName) && (item.companyName)"> - </b>
                        <b *ngIf="(item.lastName)">
                            {{item.lastName}}
                        </b>
                        <b *ngIf="(item.firstName && item.lastName) && (item.companyName)"> - </b>
                        <b *ngIf="(item.companyName)">
                            {{item.companyName}}
                        </b>
                    </span>
                </ng-template>
            </ng-select>

            <button [disabled]=disabled class="input-group-text"
                style="cursor:default ;  border-width:0;background-color: transparent;">
                <i class=" bx bx-user-plus " [ngStyle]="{'cursor': (disabled) ? 'default': 'pointer'} "
                    style=" font-weight:400 ; font-size:20px ;" (click)="openModalNewContactDropDownSearch()"></i>
            </button>

            <div style="border-right: 1px solid var(--vz-input-border); height: 1.7rem;"></div>

            <button [disabled]=disabled class="input-group-text"
                style=" border-width:0; cursor:default ; background-color: transparent;">
                <i class=" bx bx-search " [ngStyle]="{'cursor': (disabled) ? 'default': 'pointer'} "
                    style=" font-size:18px; " (click)="openPicklistModal(referenceModel)"></i>
            </button>
        </div>
    </div>
</div>